var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#595959",
    fill: "#FFF",
    transform: "rotate(-180 16 16)",
    x: 0.5,
    y: 2.5,
    width: 31,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 29.5c-.414 0-.79-.168-1.06-.44A1.495 1.495 0 0 1 .5 28v-4.5h31V28c0 .414-.168.79-.44 1.06-.27.272-.646.44-1.06.44z",
    stroke: "#595959",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    transform: "rotate(-180 24 26.5)",
    x: 23,
    y: 26,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    transform: "rotate(-180 16.5 26.5)",
    x: 14,
    y: 26,
    width: 5,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    transform: "rotate(-180 9.5 26.5)",
    x: 7,
    y: 26,
    width: 5,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.461 8h-9.923c-.673 0-1.318.257-1.794.716A2.399 2.399 0 0 0 9 10.445v5.11c0 .649.267 1.27.744 1.729a2.588 2.588 0 0 0 1.795.716h9.923c.673 0 1.318-.257 1.794-.716.477-.458.744-1.08.744-1.729v-5.11c0-.649-.267-1.27-.744-1.729A2.588 2.588 0 0 0 21.461 8zm-1.917 5.296-4.5 2.222a.357.357 0 0 1-.339-.011.33.33 0 0 1-.167-.285v-4.444a.33.33 0 0 1 .167-.285.357.357 0 0 1 .339-.01l4.5 2.221a.332.332 0 0 1 .188.297c0 .125-.073.24-.188.297v-.002z",
    fill: "#595959",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrYoutube);
export default __webpack_public_path__ + "static/media/icon-qr-youtube.015b223e259443e8e99eafceb74c358b.svg";
export { ForwardRef as ReactComponent };